
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"37.844","height":"31.286"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 7089","d":"M21.791 30.785v-3.813h3.93a1.011 1.011 0 00.916-1.439l-1.015-2.17h1.558v7.423zm-12.12 0v-7.423h2.545l-1.015 2.17a1.011 1.011 0 00.916 1.439h2.943v3.813zm2.856-14.8l.025.059.215.46H.738L6.793 1.356zm1.83 2.541a1.011 1.011 0 00.916-1.439l-.72-1.54 4.366-13.624 4.489 14 .018.053 1.356 3.545.225.588H13.675l-.463-.989.229-.6zm21.895 2.813h-8.788v-.03a.733.733 0 00.013-.094v-.049-.088-.05c0-.017-.008-.061-.013-.091 0-.015 0-.029-.008-.044a1.035 1.035 0 00-.04-.131l-.6-1.559.318-.678h7.794zM20.791 24.95h-7.085l1.317-2.813h7.794l1.316 2.813zm14.788-8.445h-9.788l-.338-.882 5.593-14.265 6.056 15.148zM2.904 18.527h7.794l1.094 2.338.222.475H1.591zm2.059 4.835h2.688v7.423H4.963zm12.12 3.609h2.688v3.813h-2.688zm12.12-3.609h2.688v7.423h-2.688z","fill":"none"}})])
          )
        }
      }
    